import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { SeFeApiService } from 'se-fe-api'
import { OrphanInvite } from 'se-resource-types/dist/lib/Ngin'

import { nginV2Headers } from '@se-po/shared-data-access-models'

@Injectable({
  providedIn: 'root',
})
export class OrphanInviteService {
  public endpoint = 'orphan_invites'

  constructor(private api: SeFeApiService) {
    // noop
  }

  public findAll(personaId: number): Observable<OrphanInvite[]> {
    const url = `${this.endpoint}?persona_id=${personaId}`
    return this.api.get<OrphanInvite[]>(url, { headers: nginV2Headers }).pipe(
      map(response => response.result)
    )
  }

  public resend(orphanInviteId: number): Observable<any> {
    const url = `${this.endpoint}/${orphanInviteId}/resend`
    return this.api.put(url, null, { headers: nginV2Headers })
  }

  public create(
    orgId: string,
    emailAddress: string,
    personaId: number
  ): Observable<OrphanInvite> {
    const url = `${this.endpoint}`
    return this.api.post<OrphanInvite>(
      url,
      { org_id: orgId,  email_address: emailAddress, persona_id: personaId },
      { headers: nginV2Headers }
    ).pipe(
      map(response => response.result)
    )
  }

  public destroy(orphanInviteId: number): Observable<OrphanInvite> {
    const url = `${this.endpoint}/${orphanInviteId}`
    return this.api
      .delete(url, { headers: nginV2Headers })
      .pipe(map((response) => response.result))
  }
}
